module.exports = __webpack_public_path__ + "media/images/ic-popup-close-4cad5bd21e3fe00ca41bb5dc9a771266.svg";